import React, { useState, useRef } from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import {
  EVButton, EVList, EVListItem, EVPaper, EVGrid, EVKeyboardArrowUp, EVKeyboardArrowDown, makeStyles,
} from 'lib/components';
import { UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT } from 'constants/ActionTypes';
import Popper from 'commonComponents/popper';
import ClearButton from 'features/orderHistory/components/filters/commonComponents/clearButton';

const useStyles = makeStyles(() => ({
  productFilterContainer: {
    height: '44px',
    width: '100%',
    position: 'relative',
    '@media (min-width: 1024px)': {
      width: 'fit-content',
    },
  },
  filterOptionsPaper: {
    marginTop: '4px',
    maxHeight: '200px',
    overflowX: 'auto',
    overflowY: 'auto',
    minWidth: '200px',
    '@media (min-width: 1024px)': {
      maxHeight: '400px',
    },
  },
  productsFilterButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #B4BAC7',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '8px',
    cursor: 'pointer',
    width: '100%',
    minWidth: '160px',
    height: '44px',
    fontSize: '16px',
    fontWeight: '400',
    '@media (min-width: 1024px)': {
      maxHeight: '400px',
    },
  },
}));
function ProductsFilter() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    selectedProduct,
    productsList,
  } = useSelector(({ analyticsDashboard }) => ({
    selectedProduct: analyticsDashboard.reportAnalyticsFilters.selectedProduct,
    productsList: analyticsDashboard.productsList,
  }));

  const handleChange = (id) => {
    dispatch({ type: UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT, selectedProduct: id });
  };

  const selectRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl((el) => (el ? null : event.currentTarget));

  const handleClose = () => setAnchorEl(null);
  const selectedProductName = productsList?.find((product) => product.id === selectedProduct)?.name;
  // #genai - Resolve the unselected-state icon outside the button markup.
  const menuStateIcon = anchorEl
    ? <EVKeyboardArrowUp onClick={handleClose} />
    : <EVKeyboardArrowDown />;

  return (
    <EVGrid
      className={classes.productFilterContainer}
      ref={selectRef}
    >
      <EVButton
        id="products-filter-button"
        variant="outlined"
        onClick={handleMenuOpen}
        className={classes.productsFilterButton}
      >
        {selectedProductName || 'Products'}
        {selectedProduct ? (
          <ClearButton
            id="clear-products-btn"
            handleClear={() => dispatch({ type: UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT, selectedProduct: null })}
            style={{ padding: 0 }}
          />
        ) : menuStateIcon}
      </EVButton>
      <Popper
        popperId="products-filter-popper"
        style={{
          zIndex: 500, left: 0, right: 0,
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-end"
        onClickAway={handleClose}
        disablePortal
      >
        <EVPaper className={classes.filterOptionsPaper}>
          <EVList style={{ padding: '0px' }}>
            {productsList?.map((option) => (
              <EVListItem
                data-testid={`products-list-item-${option.id}`}
                button
                key={option.id}
                onClick={() => { handleChange(option.id); }}
              >
                {option.name}
              </EVListItem>
            ))}
          </EVList>
        </EVPaper>
      </Popper>
    </EVGrid>
  );
}

export default ProductsFilter;
